import { render, staticRenderFns } from "./MuralDashboard.vue?vue&type=template&id=3e07d7ee&"
import script from "./MuralDashboard.vue?vue&type=script&lang=js&"
export * from "./MuralDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports